<template>
    <div class="emailcase-box">
        <div class="backimage">
            <h3 class="caption">{{emailcaseData.caption}}</h3>
            <p class="title" v-html='emailcaseData.title'></p>
        </div>
        <div class="case-box black">
            <div class="item-box" v-for='(item,index) in emailcaseData.itemData'
                :style='{backgroundImage:"url("+item.imgurl+")"}'>
                <div class="text-box">
                    <div class="bg" v-html='item.bg'></div>
                    <div class="js">{{item.js}}</div>
                    <div class="number">{{'0'+(index+1)}}</div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        name: 'EmailCase',
        data() {
            return {
                emailcaseData: {
                    caption: '邮件营销案例',
                    title: '还在为客户开发犯愁的吗？<br/>还在为从广交会收集来的客户名片从何开发犯愁吗？<br/>还在为如何开发公司CRM公海池的客户抓耳挠腮吗？<br/>蓝鲸已经成功帮助多家优质企业通过专业邮件营销开发了数名优质潜客。',
                    itemData: [
                        {
                            imgurl: 'https://lanjingshuziguanwang-public.oss-cn-hangzhou.aliyuncs.com/IMG/project/comi/%E5%8D%AB%E6%B5%B4%E8%A1%8C%E4%B8%9A.jpg',
                            bg: '客户背景:<br/>从事卫浴行业30年，长期参加海内外展会，收集到了大量客户名片约8000张。',
                            js: '蓝鲸通过邮件营销主题三板斧，首次发送邮8000封，收到18封来自全球潜在客户的询价和进一步咨询。效果立竿见影。'
                        },
                        {
                            imgurl: 'https://lanjingshuziguanwang-public.oss-cn-hangzhou.aliyuncs.com/IMG/project/comi/%E7%81%AF%E5%85%B7.jpg',
                            bg: '客户背景:<br/>温州老牌灯具厂，客户开发仅靠线下展会，无任何线上渠道推送公司产品资讯。',
                            js: '蓝鲸运营团队借助邮件营销引流， 引导至企业官网，通过优质的产品设计，让潜在客户在网站上留下询盘。'
                        },
                        {
                            imgurl: 'https://lanjingshuziguanwang-public.oss-cn-hangzhou.aliyuncs.com/IMG/project/comi/%E9%98%80%E9%97%A8.jpg',
                            bg: '客户背景:<br/>温州永嘉阀门客户，客户提供了将近30,000个邮件列表。',
                            js: '在邮箱主题模板定制方面：我们制作了产品介绍、企业公司介绍、制造质量控制介绍等主题邮件，高效激活了优质潜在客户50+。'
                        }
                    ]
                }
            }
        }
    }
</script>
<style scoped>
    .emailcase-box {
        position: relative;
    }

    .backimage {
        height: 626px;
        background: #666666 url('https://lanjingshuziguanwang-public.oss-cn-hangzhou.aliyuncs.com/IMG/project/pexels-photo-365194.jpg') no-repeat center;
        background-size: cover;
        background-attachment: fixed;
        padding-top: 102px;
        padding-left: 140px;
    }

    .caption {
        color: rgba(255, 255, 255, 1);
        margin-bottom: 33px;
        font-size: 42px;
        font-weight: 400;
        line-height: 59px;


    }

    .title {
        font-size: 14px;
        font-weight: 400;
        line-height: 32px;
        color: rgba(255, 255, 255, 1);
    }

    .case-box {
        width: 85%;
        display: grid;
        grid-template-columns: 1fr 1fr 1fr;
        grid-column-gap: 16px;
        margin: 0 auto;
        background-color: transparent;
        transform: translateY(-20%);
    }

    .item-box {
        /* background-color: #ffffff; */
        background: #ffffff no-repeat top;
        /* background-position:top;
        background-repeat: no-repeat; */
        background-size: 100% auto;
        height: 706px;
        transition: all 10s;
        position: relative;
        cursor: pointer;
        display: flex;
        align-items: flex-end;
    }

    .item-box:hover {
        background-position: 0px 100%;
    }

    .text-box {
        padding:0 5%;
        overflow: hidden;
        bottom: 0;
        width: 100%;
        height: 366px;
        background-color: #ffffff;
        transition: all 0.5s;
    }

    .item-box:hover .text-box {
        height: 0px;
    }

    .number {
        font-size: 120px;
        font-weight: bold;
        color: rgba(241, 241, 241, 1);
        position: absolute;
        bottom: 0;
        right: 13px;

    }

    .bg {
        margin-top: 60px;
        font-size: 16px;
        font-weight: 400;
        line-height: 30px;
        position: relative;
        z-index: 3;
    }

    .js {
        margin-top: 16px;
        font-size: 16px;
        color: #999999;
        font-weight: 400;
        line-height: 30px;
        position: relative;
        z-index: 3;
    }

    @media(max-width: 995px){
        .case-box {
        width: 100%;
        display: grid;
        grid-template-columns: 1fr;
        grid-row-gap: 2%;
        margin: 0 auto;
        background-color: transparent;
        transform: translateY(0%);
    }
    .backimage {
        height: auto;
        background-attachment: initial;
        padding: 5%;
    }
    .caption {
        margin-bottom:5%;
        font-size: 24px;
        line-height: 140%;


    }

    .title {
        font-size: 16px;
        line-height: 228%;
    }
    }

    /* @media(max-width: 1023px) {
        .caption {
            font-size: 75px;
            line-height: 140%;


        }

        .title {
            font-size: 50px;
            line-height: 228%;
        }

        .backimage {
            height: 1226px;
            background-attachment: initial;
        }

        .case-box {
            width: 80%;
            grid-template-columns: 1fr;
            grid-row-gap: 3%;
            bottom: 50%;
            left: 50%;
            transform: translate(-50%, 53%);
        }

        .emailcase-box {
            padding-bottom: 8019px;
        }

        .item-box {
            height: 2506px;
        }

        .bg {
            font-size: 50px;
            line-height: 187.5%;
        }

        .js {
            font-size: 50px;
            line-height: 187.5%;
        }

        .text-box {
            padding: 0px 63px;
            height: 700px;
        }
    }
    @media(max-width: 421px){
        .text-box {
            padding: 0px 63px;
            height: 1000px;
        }
    } */
</style>


// WEBPACK FOOTER //
// src/components/main/project/emailCase.vue